// extracted by mini-css-extract-plugin
var _1 = "MobileMenu__MobileMenu___QnbNy";
var _2 = "MobileMenu__badges___IHvnr";
var _3 = "MobileMenu__close___VBwbZ";
var _4 = "MobileMenu__links___iQU8J";
var _5 = "MobileMenu__open___Ll7np";
var _6 = "MobileMenu__wiggle___gNY6Q";
export { _1 as "MobileMenu", _2 as "badges", _3 as "close", _4 as "links", _5 as "open", _6 as "wiggle" }
